import { defineMessages } from 'react-intl';

export default defineMessages({
  description: 'No data to show yet',
});
